var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-10"},[_vm._v("\n  "+_vm._s(_vm.value)+"\n  "),_c('vue-slider',{attrs:{"min":60,"max":99},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }